import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { RenderFn } from 'src/types/widgets';
import normalizeWidgetInput from 'src/common/normalizeWidgetInput';
import widgetDefinition from './RoiCalculator.widget.js';
import configuration from './data/index';
import Banking from './components/Banking';
import jsondata from './utils/json/staticdata.json';
import ReactGA from 'react-ga4';
import { GATags } from 'src/common/utils/GATags';

import 'carbon-components/css/carbon-components.min.css';

ReactGA.initialize(GATags.ROI_CALCULATOR_BANKING);

const render: RenderFn = async function (instanceId, langCode, origin, cb) {
  const { element, locale, messages } = await normalizeWidgetInput(
    instanceId,
    langCode,
    widgetDefinition,
  );

  if (!element || !locale) {
    return;
  }

  ReactDOM.render(
    <React.StrictMode>
      <IntlProvider locale={locale} messages={messages}>
        <Banking configuration={configuration} jsondata={jsondata} />
      </IntlProvider>
    </React.StrictMode>,
    element,
    () => cb(element),
  );
};

export default render;
